interface documentType {
    country?: string;
    edition?: string;
    machineReadableTravelDocument?: string;
    type?: string;
  }
  
  export interface ICommon {
    documentPortrait?: string;
    mrz?: string;
    visualZone?: string;
    selfie?: string;
  }
  
  interface IAdditionalTexts {
    address?: ICommon;
    machineReadableZone?: ICommon;
    placeOfBirth?: ICommon;
    height?:ICommon;
    weight?:ICommon;
    restrictions?:ICommon;
    eyesColor:ICommon;
    hair:ICommon;
  }
  
  interface IPages {
    front?: string;
    back?: string;
    unknown?: string;
  }
  
  interface ILinks {
    pages: IPages;
    portrait?: string;
    signature?: string;
  }
  
  interface ICheckDigitsValidity {
    compositeCheckDigitValid?: boolean;
    dateOfBirthCheckDigitValid?: boolean;
    dateOfExpiryCheckDigitValid?: boolean;
    documentNumberCheckDigitValid?: boolean;
  }
  
  interface Itd1 {
    checkDigitsValidity?: ICheckDigitsValidity;
    dateOfBirth?: string;
    dateOfExpiry?: string;
    documentCode?: string;
    documentNumber?: string;
    gender?: string;
    givenNames?: string;
    issuingAuthority?: string;
    nationality?: string;
    surname?: string;
  }
  
  interface Imrz {
    td1?: Itd1;
  }
  
  export interface IDocument {
    additionalTexts?: IAdditionalTexts;
    dateOfExpiry?: ICommon;
    dateOfIssue?: ICommon;
    documentNumber?: ICommon;
    issuingAuthority?: ICommon;
    links?: ILinks;
    mrz?: Imrz;
    pageTypes: string[];
    type: documentType;
  }





  interface MrzInspection {
    valid: boolean;
}

interface GenderConsistency {
    viz: boolean;
    mrz: boolean;
}

interface AgeDifferenceWith {
    dateOfBirth: number;
}

interface PortraitInspection {
    genderEstimate: 'M' | 'F'; 
    genderConsistency?: GenderConsistency;
    ageEstimate?: number;
    ageDifferenceWith?: AgeDifferenceWith;
}

interface OcrConfidence {
    confidence: number;
    lowOcrConfidenceTexts: string[];
}

interface TextConsistency {
    consistent: boolean;
}

interface VisualZoneInspection {
    ocrConfidence?: OcrConfidence;
    textConsistency?: TextConsistency;
}

interface PageTampering {
    front?: {
        colorProfileChangeDetected?: boolean;
        looksLikeScreenshot?: boolean;
    };
    back?: {
        colorProfileChangeDetected?: boolean;
        looksLikeScreenshot?: boolean;
    };
    unknown?: {
      colorProfileChangeDetected?: boolean;
      looksLikeScreenshot?: boolean;
  };
}

export interface IInspectedDocumentData {
    expired?: boolean;
    mrzInspection?: MrzInspection;
    portraitInspection?: PortraitInspection;
    visualZoneInspection?: VisualZoneInspection;
    pageTampering?: PageTampering;
}


interface ScoreDetail {
    score: number;
}

export interface IInspectedDocumentDiscloseData {
    front?: {
        colorProfileChangeDetected?: ScoreDetail;
        looksLikeScreenshot?: ScoreDetail;
        documentPortraitGenuine?: ScoreDetail;
    };
    back?: {
        colorProfileChangeDetected?: ScoreDetail;
        looksLikeScreenshot?: ScoreDetail;
    };
    unknown?:{
        colorProfileChangeDetected?: ScoreDetail;
        looksLikeScreenshot?: ScoreDetail;
        documentPortraitGenuine?: ScoreDetail;
    }
}

export enum SecondaryDocumentCategories{
  BIRTH_CERTIFICATE = "secondarydocument.select.option1",
}

export enum PrimaryDocumentCategories{
  PASSPORT = "primarydocument.capture.description.passport",
  DRIVING_LICENSE = "primarydocument.capture.description.drivinglicense",
  PERMANENT_RESIDENT_CARD = "primarydocument.capture.description.permanentresidentcard",
  GENERAL_IDENTIFICATION_CARD = "primarydocument.capture.description.generalidentificationcard"
}

export enum PrimaryDocumentErrorCodes{
  /** The engine has no template for this document and cannot read it. */
  DOCUMENT_NOT_SUPPORTED = "DOCUMENT_NOT_SUPPORTED",
  /**
   * The engine read the document; the issuer's accepted list is what refuses it.
   * Distinct from NOT_SUPPORTED because the remedy is different — a better photo
   * can rescue the first, only a different document can rescue this.
   */
  DOCUMENT_NOT_ACCEPTED = "DOCUMENT_NOT_ACCEPTED",
  DOCUMENT_NOT_RECOGNIZED = "DOCUMENT_NOT_RECOGNIZED",
  CARD_CORNERS_NOT_DETECTED = "CARD_CORNERS_NOT_DETECTED",
  DOCUMENT_IS_A_SCREENSHOT = "DOCUMENT_IS_A_SCREENSHOT",
  DOCUMENT_COLOR_TAMPERED = "DOCUMENT_COLOR_TAMPERED",
  DOCUMENT_HAS_EXPIRED = "DOCUMENT_HAS_EXPIRED",
  DOCUMENT_PAGES_DOES_NOT_MATCH = "DOCUMENT_PAGES_DOES_NOT_MATCH",
  DOCUMENT_BARCODE_NOT_DETECTED = "DOCUMENT_BARCODE_NOT_DETECTED"
}